module.exports = __webpack_public_path__ + "img/do-something.d232a8d2.svg";